export const getRecipientRequestPath = (token = ':token') => `/r/${token}`;
